// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import actionTypes from "@adyen/adyen-web/dist/types/core/ProcessResponse/PaymentAction/actionTypes";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import {
    EventModel,
    EventsCollectionModel,
    GetEventsApiParameter,
    Pagination,
    TrainingFacetsModel,
    TrainingFacetValue,
} from "@werner/App/Services/EventService";

import produce, { Draft } from "immer";

export type TrainingCalenderState = Readonly<{
    events: EventModel[] | null;
    facets: TrainingFacetsModel[];
    pagination: Pagination | null;
    isLoading: boolean;
    selectedFilters: any;
}>;

const initialState: TrainingCalenderState = {
    isLoading: true,
    events: [],
    facets: [],
    pagination: null,
    selectedFilters: { Topic: "", Credits: "", Location: "", Price: "", Duration: "" },
};

const reducer = {
    "TrainingCalender/SetIsLoading": (draft: Draft<TrainingCalenderState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "TrainingCalender/SetEvents": (
        draft: Draft<TrainingCalenderState>,
        action: { data: { Result: EventsCollectionModel } },
    ) => {
        draft.events = action.data.Result.Events;
        draft.facets = action.data.Result.Facets;
        draft.pagination = action.data.Result.Pagination;
        draft.isLoading = false;
    },
    "TrainingCalender/SetEventFilters": (
        draft: Draft<TrainingCalenderState>,
        action: { parent: string; name: string },
    ) => {
        draft.selectedFilters[action.parent] = action.name;
        draft.isLoading = false;
    },
};

const trainingCalender = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).trainingCalender = trainingCalender;

export type xTrainingCalenderState = {
    trainingCalender: TrainingCalenderState;
} & ApplicationState;

type TrainingCalenderReducer = {
    [key: string]: typeof trainingCalender;
};

export type EventsActions = Parameters<TrainingCalenderReducer[keyof TrainingCalenderReducer]>[1] | AnyAction;
